import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { editClient } from '../../api';
import _ from 'lodash';

// Main Payment Page component
export default function PaymentResult() {
	const location = useLocation();
	const path = location.pathname;

    const updateClient = async () => {
        const user = JSON.parse(localStorage.getItem('phs-user'))
        const params = JSON.parse(localStorage.getItem('selectedMembership'))
        if (!user || !params) return;
        await editClient(params, user.id, '?client_select_membership=true')
        _.assign(user.profile, params.profile)
    }

    if (path.includes('/success')) {
        updateClient();
		return <PaymentStatus status="success" />;
	}

    if (path.endsWith('/cancel')) {
        return <PaymentStatus status="failure" />;
    }
	// TODO: Replace with actual payment form UI
	return <div>Payment Form Goes Here</div>;
}

function PaymentStatus({ status, message }) {
	const history = typeof useHistory === 'function' ? useHistory() : null;
	if (status === 'success') {
		return (
			<div style={{ textAlign: 'center', padding: '40px 0' }}>
				<h2 style={{ color: '#27ae60', fontSize: 28, marginBottom: 16 }}>✅ Payment Successful!</h2>
				{message && <div style={{ color: '#444', fontSize: 16 }}>{message}</div>}
				<button
					style={{
						marginTop: 32,
						padding: '10px 28px',
						fontSize: 16,
						background: '#1890ff',
						color: '#fff',
						border: 'none',
						borderRadius: 6,
						cursor: 'pointer',
						boxShadow: '0 2px 8px #0001'
					}}
					onClick={() => {
						if (history) history.push('/onboarding/ready');
						else window.location.href = '/onboarding/ready';
					}}
				>
					Back to Onboarding Questionnaire
				</button>
			</div>
		);
	}
	if (status === 'failure') {
		return (
			<div style={{ textAlign: 'center', padding: '40px 0' }}>
				<h2 style={{ color: '#e74c3c', fontSize: 28, marginBottom: 16 }}>❌ Payment Failed</h2>
				{message && <div style={{ color: '#444', fontSize: 16 }}>{message}</div>}
			</div>
		);
	}
	return null;
}